import { EVENTS } from "../const"
import { AnimatedText } from "./AnimatedText"
import { Grid } from "./Grid"

export function AppFrame() {
  return (
    <div
      data-name="app-frame"
      className="fixed z-50 w-full h-screen top-0 left-0 pointer-events-none text-gray-500 text-[14px]"
    >
      <div className="absolute top-2 left-2 leading-none w-15 ">
        <AnimatedText preventUpdate content="THEY" data-reveal-duration="0.1" />
        <AnimatedText
          preventUpdate
          content="CALL ME"
          data-reveal-duration="0.2"
        />
        <AnimatedText
          preventUpdate
          content="GIULIO"
          data-reveal-duration="0.3"
        />
      </div>

      <div className="absolute top-2 left-0 w-full">
        <Grid>
          <div className="hidden lg:block lg:col-start-3 leading-none">
            <AnimatedText
              preventUpdate
              content="5.0"
              data-reveal-duration="0.3"
            />
          </div>
          <div className="col-start-2 col-span-2 lg:col-start-8 md:text-right md:text-left leading-none">
            <AnimatedText
              preventUpdate
              content="Sound: On"
              data-click-event={EVENTS.Audio.Toggle}
              data-hover-event={EVENTS.Menu.hover}
              data-out-event={EVENTS.Menu.out}
              data-reveal-duration="0.3"
            />
          </div>
        </Grid>
      </div>

      <div className="absolute top-2 left-auto right-4 w-15 text-right leading-none">
        <AnimatedText
          preventUpdate
          content="MENU"
          data-click-event={EVENTS.Menu.click}
          data-hover-event={EVENTS.Menu.hover}
          data-out-event={EVENTS.Menu.out}
          data-reveal-duration="0.6"
        />
      </div>

      <div className="absolute top-auto left-auto bottom-2 right-4 w-15 text-right hidden lg:block">
        <AnimatedText
          preventUpdate
          content="hi@giulio.me"
          data-click-event={EVENTS.Email.Click}
          data-hover-event={EVENTS.Email.Hover}
          data-out-event={EVENTS.Email.Out}
          data-reveal-duration="0.5"
        />
        <AnimatedText
          preventUpdate
          content="Open Apr 2026"
          data-reveal-duration="0.6"
        />
      </div>
    </div>
  )
}
